import axios from "axios";
import React from "react";
import { jsonHeader } from '../util/GeneralUtil'
const apiUrl = process.env.REACT_APP_API_URL;


async function getCustomerNetpisition(payload) {
    const result = await axios.post(apiUrl + "/admin/summary/netposition",payload,{
        headers: jsonHeader}
    );
    return result.data || [];
}
export const NetPositonService = {
    getCustomerNetpisition
}
